import { render } from "./FranchiseDialog.vue?vue&type=template&id=70f21dc3"
import script from "./FranchiseDialog.vue?vue&type=script&lang=js"
export * from "./FranchiseDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__